import { render } from "./ProfileDebug.vue?vue&type=template&id=7640e7a6"
import script from "./ProfileDebug.vue?vue&type=script&lang=js"
export * from "./ProfileDebug.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__